import { render, staticRenderFns } from "./header.vue?vue&type=template&id=494e6e37&scoped=true&"
import script from "./header.js?vue&type=script&lang=js&"
export * from "./header.js?vue&type=script&lang=js&"
import style0 from "./header.scss?vue&type=style&index=0&id=494e6e37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494e6e37",
  null
  
)

export default component.exports